const Features = () => {
  return (
    <div className="xs:px-10 sm:px-10 md:px-20 lg:px-40 xl:px-40 2xl:px-40 py-10 flex">
      <div className="flex flex-col gap-6">
        <h2 className="font-bold xs:text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl 2xl:text-3xl mb-4 tracking-tighter">
          What is <span className="text-sky-500">Bimaper</span>
        </h2>
        <p className="leading-relaxed text-md">
          Bimaper Technologies & Solutions Private Limited, based in Lucknow,
          Uttar Pradesh, India, is a professionally managed complete IT service
          provider. Bimaper utilises state-of-the-art infrastructure, modern
          technology, well-qualified and experienced human resources, and
          high-end software technology.
        </p>
        <p className="leading-relaxed text-md">
          <span className="font-semibold">Our mission :</span> "To become a
          globally recognised company that provides best-of-breed IT solutions,
          delivered by best-in-class people".
        </p>
        <p className="leading-relaxed text-md">
          <span className="font-semibold">Our vision :</span> Think
          unconventionally and make sure to fulfil impossible targets while
          keeping global competitiveness and social responsibility in mind.
        </p>
        <p className="leading-relaxed text-md">
          We’ll meet global standards for IT services that delight customers
          through prompt action and innovative service.
        </p>
      </div>
    </div>
  );
};
export default Features;
